import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http'; 
import { SidebarService } from '../sidebar/sidebar.service';
import { RequestService } from '../../../services/request.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit{
    unreadNotifications: number = 5;

    constructor(
        private request: RequestService,
        private http: HttpClient,
        private router: Router,
        public sidebarservice: SidebarService
      ) { }
        
    toggleSidebar() {
        this.sidebarservice.setSidebarState(!this.sidebarservice.getSidebarState());
        
        if ($("#wrapper").hasClass("nav-collapsed")) {
            // unpin sidebar when hovered
            $("#wrapper").removeClass("nav-collapsed");
            $("#sidebar-wrapper").unbind( "hover");
        } else {
            $("#wrapper").addClass("nav-collapsed");
            $("#sidebar-wrapper").hover(
                function () {
                    $("#wrapper").addClass("sidebar-hovered");
                },
                function () {
                    $("#wrapper").removeClass("sidebar-hovered");
                }
            )
      
        }
    }
    
    getSideBarState() {
        return this.sidebarservice.getSidebarState();
    }

    hideSidebar() {
        this.sidebarservice.setSidebarState(true);
    }

    fullName;
    email;
    ngOnInit() {

       this.fullName = localStorage.getItem('full_name');
        this.email = localStorage.getItem('email');
        /* Search Bar */
        $(document).ready(function () {
            $(".search-btn-mobile").on("click", function () {
                $(".search-bar").addClass("full-search-bar");
            });
            $(".search-arrow-back").on("click", function () {
                $(".search-bar").removeClass("full-search-bar");
            });
        });

        this.GetGraphData();
        this.DeviceLogReport();

    }

    rowData;
    deviceStatusData=[];
    async DeviceLogReport() {
      try {
        this.deviceStatusData=[];
        const requestData = {};
        const data: any = await this.request.post('/dashboard/view_toilet_feedback_log_data', requestData);
        for (let objKey of Object.keys(data.result)) {
          let dataObj = data.result[objKey];
          if(dataObj.feedback=="Dirty" || dataObj.feedback=="No Feedback"){
            this.deviceStatusData.push(dataObj);
          }
        }
        this.rowData = this.deviceStatusData;
        // console.log(this.rowData);
      } catch (error) {}
    }
   
    statusData;
    SendMessages(alert){
      try{
        let message = "Your assigned toilet has received a "+alert.feedback+" rating. Please ensure it is cleaned as soon as possible.\n Toilet details are as follows:\n Device ID : "+alert.device_id+"\nAddress : "+alert.address+"\nDate Time : "+alert.log_date_time;
        let email="mrityunjayk1998@gmail.com";
        let subject = "TMS Feedback Status";
        let full_name="Mrityunjay Kumar";

        let uri = "https://mapembedded.com/send_message.php";
        this.http.get(uri, {
          params: {
            type: "send_messages",
            message: message,
            email: email,
            subject: subject,
            full_name: full_name
          }
        }).subscribe(response => {
          this.statusData = response;
          for (let objKey of Object.keys(this.statusData)) {
            // console.log(this.statusData[objKey].status);
            if(this.statusData[objKey].status=="success"){
              $(".sent-message").css("display", "block");
            }else{
              $(".error-message").css("display", "block");
            }
          }
        })
      } 
      catch(error){}
    }

    errorMessage:any;
    feedbackPoor=0;
    async GetGraphData() {
      try {
        this.feedbackPoor=0;
        const requestData = {};
        const data: any = await this.request.post('/dashboard/view_graph_rating_data', requestData);
        let objData = data.result;
        // this.feedbackPoor= (objData.no_feedback+objData.poor_feedback);
        this.feedbackPoor= objData.dirty_poor_feedback;
      } catch (error) {}
    }

    logout(){
        localStorage.clear();
    }
    Notifications() {
    console.log('Notifications clicked!');
     }
}
